import { buildTheSportsWidgetUrl, resolveTheSportsProfileKey } from '@/domain/lmt';
import { cn } from '@/lib/cn';

export interface TheSportsLmtWidgetProps {
  sport: string;
  theSportsId: string;
  profileKeys: string;
  language?: string;
  className?: string;
}

/**
 * TheSports LMT via legacy c-lmt.com `wdg.html` proxy (outer iframe → inner widget).
 * Width is constrained by the header's right-hand media column on desktop.
 */
export function TheSportsLmtWidget({
  sport,
  theSportsId,
  profileKeys,
  language = 'en',
  className,
}: TheSportsLmtWidgetProps) {
  const profileKey = resolveTheSportsProfileKey(profileKeys, sport);
  if (!profileKey || !theSportsId) return null;

  const src = buildTheSportsWidgetUrl({
    lang: language,
    sport,
    profileKey,
    theSportsId,
  });

  return (
    <div
      data-container="livedetailswidget"
      className={cn(
        // Clip to 315px (c-lmt inner iframe height) so the white body strip
        // under the widget is hidden; bg matches the event header section.
        'relative z-[1] isolate h-[315px] w-full overflow-hidden bg-bg-surface leading-none',
        className,
      )}
      onTouchStart={(event) => event.stopPropagation()}
      onTouchMove={(event) => event.stopPropagation()}
    >
      <iframe
        src={src}
        id="ifrmWidget"
        title="Live match tracker"
        scrolling="no"
        className="pointer-events-auto relative z-[1] block h-[320px] w-full touch-manipulation overflow-hidden border-0 bg-bg-surface"
        allowFullScreen
      />
    </div>
  );
}
